const extractInterfaceName = (key) =>
  key?.match(/\[([^\],]+?(?=\s\-|,|\]))/)?.[1];

export default extractInterfaceName;
